import React, { useState } from "react";
import "./header.css";
import { Link, useLocation, useNavigate } from "react-router-dom";
import Logo from "../../assets/images/header/logo.png";
import MapIcon from "../../assets/images/header/map.png";
import Avatar from "../../assets/images/header/avatar.png";
import Down from "../../assets/images/header/down.png";
import Logout from "../../assets/images/header/logout.png";
import { useAppKit, useAppKitAccount, useDisconnect } from "@reown/appkit/react";
import Fox from "../../assets/images/header/fox.png";

function getStoredUser() {
  try {
    return JSON.parse(sessionStorage.getItem("user_data"));
  } catch (_) {
    return null;
  }
}

function BannerHeader() {
  const navigate = useNavigate();
  const location = useLocation();
  const { disconnect } = useDisconnect();
  const { open } = useAppKit();
  const { isConnected, address } = useAppKitAccount();
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const user = getStoredUser();
  const isAuthenticated = Boolean(sessionStorage.getItem("access_token"));
  const hasIdentity = (isConnected && address) || user?.name;

  const handleLogout = async () => {
    if (isConnected) await disconnect();
    sessionStorage.clear();
    navigate("/");
  };

  const formatAddress = (value) =>
    value ? `${value.slice(0, 4)}...${value.slice(-4)}` : "";

  const mapDestination = isAuthenticated || isConnected ? "/map" : "/login";

  const handleConnectWallet = async () => {
    try {
      await open({ view: "Connect" });
    } catch (error) {
      console.error("Unable to open wallet connection:", error);
    }
  };

  const closeMobileMenu = () => setIsMobileMenuOpen(false);

  const handleExploreMap = async (event) => {
    if (isConnected) return;

    event.preventDefault();
    await handleConnectWallet();
  };

  return (
    <header className="simule-site-header">
      <nav className="simule-site-nav" aria-label="Primary navigation">
        <Link className="simule-site-brand" to="/" aria-label="Simule home">
          <img src={Logo} alt="Simule" />
        </Link>

        <div className="simule-site-links">
          <Link to="/" className={location.pathname === "/" ? "active" : undefined}>Home</Link>
          <Link to="/help" className={location.pathname === "/help" ? "active" : undefined}>Help center</Link>
          <Link to="/whitepaper" className={location.pathname === "/whitepaper" ? "active" : undefined}>
            White paper
          </Link>
        </div>

        <div className="simule-site-actions">
          <button
            className="simule-mobile-menu-button"
            type="button"
            aria-label="Toggle navigation menu"
            aria-expanded={isMobileMenuOpen}
            onClick={() => setIsMobileMenuOpen((isOpen) => !isOpen)}
          >
            <span />
            <span />
            <span />
          </button>
          <Link to={mapDestination} className="simule-map-link" onClick={handleExploreMap}>
            <img src={MapIcon} alt="" aria-hidden="true" />
            <span>Explore map</span>
          </Link>

          {hasIdentity ? (
            <div className="dropdown simule-profile-dropdown">
              <button
                className="simule-profile-button dropdown-toggle"
                type="button"
                id="homeProfileMenu"
                data-bs-toggle="dropdown"
                aria-expanded="false"
              >
                <img
                  src={isConnected ? Fox : user?.picture || Avatar}
                  alt=""
                  className="simule-profile-avatar"
                />
                <span>{isConnected ? formatAddress(address) : user?.name}</span>
                <img src={Down} alt="" className="simule-profile-chevron" />
              </button>
              <ul className="dropdown-menu dropdown-menu-end simule-profile-menu" aria-labelledby="homeProfileMenu">
                <li className="simule-profile-summary">
                  <span>{isConnected ? "Connected wallet" : "Signed in as"}</span>
                  <strong>{isConnected ? address : user?.name}</strong>
                </li>
                <li><hr className="dropdown-divider" /></li>
                <li>
                  <button className="dropdown-item simule-logout-action" type="button" onClick={handleLogout}>
                    <img src={Logout} alt="" />
                    {isConnected ? "Disconnect wallet" : "Log out"}
                  </button>
                </li>
              </ul>
            </div>
          ) : (
            <button type="button" className="simule-connect-link" onClick={handleConnectWallet}>
              Connect wallet
            </button>
          )}
        </div>
      </nav>

      <div className={`simule-mobile-menu${isMobileMenuOpen ? " open" : ""}`}>
        <Link to="/" onClick={closeMobileMenu}>Home</Link>
        <Link to="/help" onClick={closeMobileMenu}>Help center</Link>
        <Link to="/whitepaper" onClick={closeMobileMenu}>
          White paper
        </Link>
        <Link
          to={mapDestination}
          onClick={(event) => {
            closeMobileMenu();
            handleExploreMap(event);
          }}
        >
          Explore map
        </Link>
        {!hasIdentity && (
          <button type="button" onClick={handleConnectWallet}>
            Connect wallet
          </button>
        )}
      </div>
    </header>
  );
}

export default BannerHeader;
